import React from "react";
import { IncidentForm } from "./IncidentForm";
import { ProblemForm } from "./ProblemForm";
import { ChangeForm } from "./ChangeForm";
import { ServiceRequestForm } from "./ServiceRequestForm";
import { QuestionForm } from "./QuestionForm";
import { AccessRequestForm } from "./AccessRequestForm";
import { SoftwareInstallForm } from "./SoftwareInstallForm";
import { SoftwareUpdateForm } from "./SoftwareUpdateForm";
import { NewEquipmentForm } from "./NewEquipmentForm";
import { OnboardingForm } from "./OnboardingForm";
import { OffboardingForm } from "./OffboardingForm";
import { SecurityAlertForm } from "./SecurityAlertForm";
import { OtherForm } from "./OtherForm";
import { PasswordResetForm } from "./PasswordResetForm";
import { DefectiveEquipmentForm } from "./DefectiveEquipmentForm";
import { EquipmentLoanForm } from "./EquipmentLoanForm";
import { DepartmentTransferForm as DepartmentTransferDynForm } from "./DepartmentTransferForm";
import { GeneralITRequestForm } from "./GeneralITRequestForm";
import { LicenseRequestForm } from "./LicenseRequestForm";

const FORM_REGISTRY = {
    incident: IncidentForm,
    problem: ProblemForm,
    change: ChangeForm,
    service_request: ServiceRequestForm,
    question: QuestionForm,
    access_request: AccessRequestForm,
    software_install: SoftwareInstallForm,
    software_update: SoftwareUpdateForm,
    new_equipment: NewEquipmentForm,
    onboarding: OnboardingForm,
    offboarding: OffboardingForm,
    security: SecurityAlertForm,
    other: OtherForm,
    password_reset: PasswordResetForm,
    defective_equipment: DefectiveEquipmentForm,
    equipment_loan: EquipmentLoanForm,
    department_transfer: DepartmentTransferDynForm,
    general_it_request: GeneralITRequestForm,
    license_request: LicenseRequestForm,
};

export function FormRegistry({ ticketType, onSubmit, initialData, readOnly, submitting, onTitleChange, allowedPriorities, onTypeChange }) {
    const FormComponent = FORM_REGISTRY[ticketType];

    if (!FormComponent) {
        return (
            <div className="text-center py-8 text-gray-500">
                Formulaire non disponible pour ce type de ticket
            </div>
        );
    }

    return (
        <FormComponent
            onSubmit={onSubmit}
            initialData={initialData}
            readOnly={readOnly}
            submitting={submitting}
            onTitleChange={onTitleChange}
            allowedPriorities={allowedPriorities}
            ticketType={ticketType}
            onTypeChange={onTypeChange}
        />
    );
}
